/**
 * BrandGlyph：品牌区允许的唯一图形——一个 28–32px 单字/双字标（11-ui-kit「导航图标登记制」修订②，
 * 2026-09-05 dzy 授权推翻 2026-08-26「品牌区一律纯文字，禁止 logo 色块/首字块」裁决）。
 * 纯展示、无业务语义：内容（通常是应用中文简称的首字）由调用方传入，不在包内生成缩写。
 * 默认 aria-hidden——品牌区旁边总有应用名文本，可达名称由那段文字承担，这里只是视觉强调。
 *
 * 命名没有直接叫 `BrandMark`：`apps/crm/src/patterns/BrandMark.tsx`（crm 自有的三柱形登录页
 * 品牌图形，早于本单存在、`tests/ui-consistency-guard.test.ts` 的 `WHITE_CLASS_BASELINE` 与
 * `docs/archive/rewrite/2026-08-11-task-02b-ui-migrate-apps.md` 均有登记）已经占用这个名字；
 * `tests/ui-patterns-guard.test.ts`（T11 边界规则）禁止 `patterns/` 与 `@bf/ui` 同名值导出且
 * 明确不接受新增 KNOWN 豁免（"任何新增条目不允许出现"）。crm 那份是业务 app 代码，退役/改名
 * 归 Twin-112/113（本单"只改底座与模板"），故包内用不冲突的 `BrandGlyph`，语义不变。
 */
import type { ReactNode } from 'react'

export type BrandGlyphProps = {
  children: ReactNode
  /** 边长 px，建议 28–32（11-ui-kit §9.3「品牌区」规格） */
  size?: number
  className?: string
}

export function BrandGlyph({ children, size = 32, className = '' }: BrandGlyphProps) {
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size }}
      className={`flex shrink-0 items-center justify-center rounded-[var(--radius-md)] bg-[var(--color-primary)] text-sm font-bold text-[var(--color-on-primary)] ${className}`.trim()}
    >
      {children}
    </span>
  )
}
